/**
 * Buildings datatable service.
 *
 * Calls the existing /buildings/datatable endpoint using the serialized
 * URLSearchParams produced by buildingsStateSerializer.
 *
 * The endpoint contract is unchanged — this service is a thin HTTP adapter.
 * Errors are re-thrown (not swallowed) so they propagate to React Query's
 * error state.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import api from '@utils/axios';
import { serializeBuildingsRequest } from '../adapters/buildingsStateSerializer';
const BUILDINGS_DATATABLE_PATH = '/buildings/datatable';
/**
 * Fetches one page of buildings from the server.
 * Throws on HTTP error so React Query surfaces it as `error` state.
 */
export function fetchBuildings(state) {
    return __awaiter(this, void 0, void 0, function* () {
        const params = serializeBuildingsRequest(state);
        const response = yield api.get(BUILDINGS_DATATABLE_PATH, {
            params
        });
        return response.data;
    });
}
